import React from 'react';
import { Trophy, Star, Award, Users, TrendingUp } from 'lucide-react';

// Versão grande de VencedorDestaqueGenerico.js — mesmo hero de página
// inteira que VencedorDestaque.js já usa pro Telão Brasil (badge + troféu
// saltando + card gradiente + par de indicadores + caixa de destaque), só
// que com texto genérico em vez de copy específico de local/telão. Quem
// decide QUANDO usar essa versão (múltipla escolha ou pergunta de duas
// opções, só depois que a enquete encerrou) é CardPergunta em
// ResultadoEnqueteDinamica.js — este componente aqui só desenha.
//
// `itens` (opcional, todas as opções da pergunta) é o que permite o 3º
// indicador de "diferença pro 2º colocado" — mesma ideia da EstatisticasGerais
// da tela legada do Telão Brasil ("Diferença do 1º"), mas calculada de
// verdade a partir dos votos reais de cada opção em vez de vir de fora.
const VencedorDestaqueGrande = ({ vencedor, totalRespondentes, itens }) => {
  if (!vencedor || vencedor.votos === 0) return null;

  const porcentagem = totalRespondentes > 0
    ? ((vencedor.votos / totalRespondentes) * 100).toFixed(1)
    : 0;

  const ordenados = [...(itens || [])].sort((a, b) => b.votos - a.votos);
  const diferencaSegundo = ordenados.length > 1 ? vencedor.votos - ordenados[1].votos : null;

  return (
    <div className="mb-6 animate-fade-in-up">
      <div className="flex justify-center mb-4">
        <div className="bg-gradient-to-r from-yellow-400 to-amber-500 text-white px-6 py-2 rounded-full shadow-lg flex items-center gap-2">
          <Trophy className="w-5 h-5" />
          <span className="font-bold text-lg">OPÇÃO VENCEDORA</span>
        </div>
      </div>

      <div className="relative bg-gradient-to-br from-yellow-50 via-amber-50 to-yellow-100 border-4 border-yellow-400 rounded-2xl p-8 shadow-2xl overflow-hidden">
        <div className="absolute top-0 right-0 w-64 h-64 bg-yellow-200 rounded-full opacity-20 blur-3xl -mr-32 -mt-32" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-200 rounded-full opacity-20 blur-3xl -ml-32 -mb-32" />

        <div className="relative z-10">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <Trophy className="w-24 h-24 text-yellow-600 animate-trofeu-pular" />
              <div className="absolute inset-0 w-24 h-24 bg-yellow-400 rounded-full blur-xl opacity-50 animate-pulse" />
            </div>
          </div>

          <h2 className="text-3xl md:text-4xl font-black text-center text-gray-900 mb-4">
            {vencedor.label}
          </h2>

          <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-6">
            <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full shadow-md">
              <Users className="w-6 h-6 text-yellow-600" />
              <span className="text-2xl font-bold text-gray-900">{vencedor.votos.toLocaleString('pt-BR')}</span>
              <span className="text-gray-600 font-medium">votos</span>
            </div>

            <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full shadow-md">
              <Star className="w-6 h-6 text-yellow-600" />
              <span className="text-2xl font-bold text-gray-900">{porcentagem}%</span>
              <span className="text-gray-600 font-medium">dos votos</span>
            </div>

            {diferencaSegundo !== null && (
              <div className="flex items-center gap-2 bg-white/80 backdrop-blur-sm px-6 py-3 rounded-full shadow-md">
                <TrendingUp className="w-6 h-6 text-yellow-600" />
                <span className="text-2xl font-bold text-gray-900">+{diferencaSegundo.toLocaleString('pt-BR')}</span>
                <span className="text-gray-600 font-medium">à frente do 2º</span>
              </div>
            )}
          </div>

          <div className="bg-white/90 backdrop-blur-sm border-2 border-yellow-300 rounded-xl p-6 text-center shadow-lg">
            <Award className="w-8 h-8 text-yellow-600 mx-auto mb-3" />
            <p className="text-xl font-bold text-gray-900 mb-2">
              🎉 Esta foi a opção mais escolhida!
            </p>
            <p className="text-gray-700">
              Escolhida pela maioria de quem respondeu esta pergunta.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VencedorDestaqueGrande;
